<template>
  <div class="h-screen flex flex-col justify-center items-center bg-primary">
    <div class="flex flex-col gap-5 justify-center text-center text-white ">
      <p class="quicksand-600 text-3xl">Jammy Trip</p>
      <p class="quicksand-300">Disponibile per dispositivi mobile</p>
      <img src="/imgs/qr.png" alt="qr code" class="w-[200px] m-auto" />
      <p>jammytrip.netlify.app</p>
    </div>
  </div>
</template>